import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { useIcon } from "../../../hooks/useIcon/index.mjs";
import { IconCancelOutlineSvg } from "./IconCancelOutlineSvg.mjs";
const IconCancelOutline = (props) => {
  const iconProps = useIcon(props);
  return /* @__PURE__ */ jsx(Box, { component: IconCancelOutlineSvg, ...iconProps });
};
export {
  IconCancelOutline
};
